export default __webpack_public_path__ + "MelodyVideo.acc26e30.mov";